import React from'react'
import './donutspinner.css'

const DonutSpinner = ()=> {
    
    return (
        <>
        <section className = "page">
        <div className = "donut-spinner"></div>
        </section>
        </>
    )
}

export default DonutSpinner;